import React, { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import BackButton from '../../components/BackButton';
import MailOpenTableDetails from '../../components/MailOpenTableDetails';

const MailOpenUserDetails = () => {
  const location = useLocation();
  const { mailDetails } = location.state || {};
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // Function to format ISO 8601 date string
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date'; // Fallback for invalid date
    return date.toLocaleString(); // Format to locale date-time
  };
  // Pagination logic
  const mailOpenDetails = mailDetails?.mailOpenDetails || [];
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = mailOpenDetails.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil(mailOpenDetails.length / itemsPerPage);
  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Render message when no data
  if (!mailDetails) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-gray-600">No data found.</div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-6">
      <BackButton/>
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Open Details</h1>

        {/* Summary Card */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* <div>
              <h3 className="text-sm font-semibold text-gray-600">MailLog ID</h3>
              <p className="text-sm text-gray-800 break-all">{mailDetails.mailLogId || 'N/A'}</p>
            </div> */}
            <div>
              <h3 className="text-sm font-semibold text-gray-600">Mail Open Count</h3>
              <p className="text-sm text-gray-800 break-all">{mailDetails.mailOpenCount || 'N/A'}</p>
            </div>
            {/* <div>
              <h3 className="text-sm font-semibold text-gray-600">No Of Buttons</h3>
              <p className="text-lg text-gray-800">{mailDetails.noOfButtons || 'N/A'}</p>
            </div> */}
          </div>
        </div>
              {/* Summary Card
<div className="bg-gray-50 rounded-lg p-4 mb-6">
  <div className="flex justify-between items-center">
    <div>
      <h3 className="text-sm font-semibold text-gray-600">MailLog ID</h3>
      <p className="text-sm text-gray-800 break-all">{mailDetails.mailLogId || 'N/A'}</p>
    </div>
    <div>
      <h3 className="text-sm font-semibold text-gray-600">Mail Open Count</h3>
      <p className="text-sm text-gray-800 break-all">{mailDetails.mailOpenCount || 'N/A'}</p>
    </div>
  </div>
</div> */}

        {/* Location Details Table */}
        <MailOpenTableDetails
          mailOpenDetails={mailOpenDetails}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          paginate={paginate}
          formatDate={formatDate}
        />
      </div>
    </div>
  );
};

export default MailOpenUserDetails;
